"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceTelemetryType = void 0;
/**
 * Formerly known as DeviceMonitoringType.
 * Defines all possible telemetries reported by devices.
 * Some of those items can be managed from server on the device and those should have its same named alternative DeviceSettingsType.
 * `DeviceTelemetryType` loosely corresponts with with `TelemetryConfigurationCheckInterval`
 */
var DeviceTelemetryType;
(function (DeviceTelemetryType) {
    DeviceTelemetryType["VOLUME"] = "VOLUME";
    DeviceTelemetryType["BRIGHTNESS"] = "BRIGHTNESS";
    DeviceTelemetryType["TIMERS"] = "TIMERS";
    DeviceTelemetryType["PROPRIETARY_TIMERS"] = "PROPRIETARY_TIMERS";
    DeviceTelemetryType["RESOLUTION"] = "RESOLUTION";
    DeviceTelemetryType["ORIENTATION"] = "ORIENTATION";
    DeviceTelemetryType["REMOTE_CONTROL"] = "REMOTE_CONTROL";
    DeviceTelemetryType["APPLICATION_VERSION"] = "APPLICATION_VERSION";
    DeviceTelemetryType["FIRMWARE_VERSION"] = "FIRMWARE_VERSION";
    DeviceTelemetryType["DEBUG"] = "DEBUG";
    DeviceTelemetryType["DATETIME"] = "DATETIME";
    DeviceTelemetryType["POWER_ACTIONS_SCHEDULE"] = "POWER_ACTIONS_SCHEDULE";
    DeviceTelemetryType["TEMPERATURE"] = "TEMPERATURE";
    DeviceTelemetryType["BUNDLED_APPLET"] = "BUNDLED_APPLET";
    DeviceTelemetryType["AUTO_RECOVERY"] = "AUTO_RECOVERY";
    DeviceTelemetryType["PEER_RECOVERY"] = "PEER_RECOVERY";
    DeviceTelemetryType["PROXY"] = "PROXY";
    DeviceTelemetryType["WIFI_STRENGTH"] = "WIFI_STRENGTH";
    DeviceTelemetryType["FRONT_CAPABILITIES"] = "FRONT_CAPABILITIES";
    DeviceTelemetryType["MANAGEMENT_CAPABILITIES"] = "MANAGEMENT_CAPABILITIES";
    DeviceTelemetryType["DISPLAY_SETTING"] = "DISPLAY_SETTING";
    DeviceTelemetryType["INPUT_SOURCE"] = "INPUT_SOURCE";
    DeviceTelemetryType["FRONT_DISPLAY_VERSION"] = "FRONT_DISPLAY_VERSION";
    /** @deprecated Use ONLINE_STATUS instead. Keep long-term support. */
    DeviceTelemetryType["OFFLINE_RANGE"] = "OFFLINE_RANGE";
    DeviceTelemetryType["ONLINE_STATUS"] = "ONLINE_STATUS";
    DeviceTelemetryType["CONNECTION_METHOD"] = "CONNECTION_METHOD";
    DeviceTelemetryType["EXTENDED_MANAGEMENT"] = "EXTENDED_MANAGEMENT";
    DeviceTelemetryType["EXTENDED_CONTROL"] = "EXTENDED_CONTROL";
    DeviceTelemetryType["NETWORK_INTERFACES"] = "NETWORK_INTERFACES";
    DeviceTelemetryType["DISPLAY_POWER_ON"] = "DISPLAY_POWER_ON";
    DeviceTelemetryType["STORAGE"] = "STORAGE";
    DeviceTelemetryType["APP_MODULES"] = "APP_MODULES";
    DeviceTelemetryType["FEATURE_FLAGS"] = "FEATURE_FLAGS";
    DeviceTelemetryType["CRYPTOGRAPHIC_KEY"] = "CRYPTOGRAPHIC_KEY";
    DeviceTelemetryType["APPLET"] = "APPLET";
    DeviceTelemetryType["PLUGIN"] = "PLUGIN";
    DeviceTelemetryType["RUNNER"] = "RUNNER";
    DeviceTelemetryType["RUNNER_CUSTOM"] = "RUNNER_CUSTOM";
    DeviceTelemetryType["CPU_USAGE"] = "CPU_USAGE";
    DeviceTelemetryType["MEMORY_USAGE"] = "MEMORY_USAGE";
    DeviceTelemetryType["INSTALLED_PACKAGES"] = "INSTALLED_PACKAGES";
    DeviceTelemetryType["CLIENT_PUBLIC_IP"] = "CLIENT_PUBLIC_IP";
    DeviceTelemetryType["SUPRA"] = "SUPRA";
})(DeviceTelemetryType || (exports.DeviceTelemetryType = DeviceTelemetryType = {}));
